import { useQuery } from '@tanstack/react-query'
import { gqlRequest, type RequestSession } from './api/client'
import { ConfigurationQuery } from './api/operations'
import { readConfiguration } from './configuration'

export function useConfiguration(session: RequestSession, restaurantId: string) {
  const query = useQuery({
    queryKey: ['configuration', session.mode, restaurantId],
    enabled: Boolean(session.token && restaurantId),
    queryFn: async () => {
      const data = await gqlRequest(session, ConfigurationQuery, { restaurantId })
      const rows = data.restaurant?.configuration?.edges ?? []
      if (rows.length > 1) throw new Error('Flera skärmkonfigurationer hittades. Kontrollera inställningarna i backoffice.')
      // Validate inside the query: React Query retains the last valid configuration
      // during a network error rather than reverting a running kitchen to defaults.
      const config = readConfiguration(rows[0]?.node.document)
      return { ...data, config }
    },
    refetchInterval: 30_000,
  })
  return { ...query, config: query.data?.config ?? readConfiguration(undefined) }
}
